import React from 'react';
import QuizCart from '../QuizCart/QuizCart';

const Quiz = ({ quizes }) => {
    // const [id, logo, name, total] = quizes;

    const quizQuestions = (id) => {
        const quizId = quizes.find(quiz => quiz.id === id);
        return quizId;

    }
    return (
        <div>
            {
                quizes.map(quiz => <QuizCart
                    key={quiz.id}
                    quiz={quiz}
                    quizQuestions={quizQuestions}

                ></QuizCart>)
            }

        </div>
    );
};

export default Quiz;